import { ToastDesignTokens } from '@primeuix/themes/types/toast'

const index: ToastDesignTokens = {
  text: {
    gap: '0.25rem'
  },
  summary: {
    fontSize: '0.9rem'
  },
  detail: {
    fontWeight: '450',
    fontSize: '0.8rem'
  },
  colorScheme: {
    light: {
      success: {
        background: '{success.background.color}',
        detailColor: '{success.color}',
        borderColor: '{success.border.color}',
        closeButton: {
          focusRing: {
            color: '{success.color}'
          }
        }
      },
      info: {
        background: '{info.background.color}',
        detailColor: '{info.color}',
        borderColor: '{info.border.color}',
        closeButton: {
          focusRing: {
            color: '{info.color}'
          }
        }
      },
      warn: {
        background: '{warning.background.color}',
        detailColor: '{warning.color}',
        borderColor: '{warning.border.color}',
        closeButton: {
          focusRing: {
            color: '{warning.color}'
          }
        }
      },
      error: {
        background: '{danger.background.color}',
        detailColor: '{danger.color}',
        borderColor: '{danger.border.color}',
        closeButton: {
          focusRing: {
            color: '{danger.color}'
          }
        }
      }
    }
  }
}

const pt = {
  root: {
    style: {
      zIndex: '11200'
    }
  }
}

export { index as default, pt }
